export default {
  '***': {
    '***': {
      '***': [
        {
          "id": 10,
          "label": "Brand Image",
          "selected": 0,
          "collapse": 0,
          "parent": 0,
          "children": [
            20,
            25,
            30,
            40,
            50
          ],
          "tooltip": "This will be checked automatically when any item in this section is checked."
        },
        {
          "id": 20,
          "label": "Awards/Accolades",
          "selected": 0,
          "collapse": 0,
          "parent": 10,
          "children": [],
          "tooltip": "Refers to any reference of awards or rankings, 3rd party or commissioned research based."
        },
        {
          "id": 25,
          "label": "Customer Service",
          "selected": 0,
          "collapse": 0,
          "parent": 10,
          "children": [],
          "tooltip": "Refers to a primary focus on customer service"
        },
        {
          "id": 30,
          "label": "Co-Brand",
          "selected": 0,
          "collapse": 0,
          "parent": 10,
          "children": [],
          "tooltip": "Single ad advertising for more than one brand ('Seamless + Taco Bell' or 'Marriott Chase credit card')"
        },
        {
          "id": 40,
          "label": "General Reputation",
          "selected": 0,
          "collapse": 0,
          "parent": 10,
          "children": [],
          "tooltip": "Refers to any ad that focuses on a brand's general reputation, but does not mention any products"
        },
        {
          "id": 50,
          "label": "Sponsorship",
          "selected": 0,
          "collapse": 0,
          "parent": 10,
          "children": [],
          "tooltip": "Sponsorship of an event, sport or project (such as a food bank)"
        },
        {
          "id": 60,
          "label": "Creative Type",
          "selected": 0,
          "collapse": 0,
          "parent": 0,
          "children": [
            70,
            80,
            90,
            95
          ],
          "tooltip": "This will be checked automatically when any item in this section is checked."
        },
        {
          "id": 70,
          "label": "Narrative",
          "selected": 0,
          "collapse": 0,
          "parent": 60,
          "children": [],
          "tooltip": "Ad follows a story trajectory, even if short"
        },
        {
          "id": 80,
          "label": "Vignette/Montage",
          "selected": 0,
          "collapse": 0,
          "parent": 60,
          "children": [],
          "tooltip": "Ad does not have a story, but rather many different scenes cut together"
        },
        {
          "id": 90,
          "label": "Animated",
          "selected": 0,
          "collapse": 0,
          "parent": 60,
          "children": [],
          "tooltip": "At least half of ad is cartoon/animation and not filmed"
        },
        {
          "id": 95,
          "label": "Graphics/Product Images Only",
          "selected": 0,
          "collapse": 0,
          "parent": 60,
          "children": [],
          "tooltip": "Ad is a computer generated ad usually focusing on a product with few or no actual filmed scenes/beauty shots"
        },
        {
          "id": 100,
          "label": "Creative Style",
          "selected": 0,
          "collapse": 0,
          "parent": 0,
          "children": [
            110,
            120,
            130,
            140,
            150,
            160,
            170,
            180,
            190
          ],
          "tooltip": "This will be checked automatically when any item in this section is checked."
        },
        {
          "id": 110,
          "label": "Humorous",
          "selected": 0,
          "collapse": 0,
          "parent": 100,
          "children": [],
          "tooltip": "The intent of the ad is to make you laugh"
        },
        {
          "id": 120,
          "label": "Emotional",
          "selected": 0,
          "collapse": 0,
          "parent": 100,
          "children": [],
          "tooltip": "The intent of the ad is to elicit sad or heartwarming emotion"
        },
        {
          "id": 130,
          "label": "Spokesperson",
          "selected": 0,
          "collapse": 0,
          "parent": 100,
          "children": [],
          "tooltip": "Includes both celebrity and non-celebrity spokespeople"
        },
        {
          "id": 140,
          "label": "Celebrity (for brand NOT content)",
          "selected": 0,
          "collapse": 0,
          "parent": 100,
          "children": [],
          "tooltip": "Includes any celebrity inclusion, whether or not that person is a spokesperson"
        },
        {
          "id": 150,
          "label": "Music (jingle)",
          "selected": 0,
          "collapse": 0,
          "parent": 100,
          "children": [],
          "tooltip": "Refers to a consistent jingle associated with a brand, not just background music"
        },
        {
          "id": 160,
          "label": "Music (lyrics/song)",
          "selected": 0,
          "collapse": 0,
          "parent": 100,
          "children": [],
          "tooltip": "Refers to an identifiable song - either lyrics or instrumental"
        },
        {
          "id": 170,
          "label": "Branding in Intro (First 5 seconds)",
          "selected": 0,
          "collapse": 0,
          "parent": 100,
          "children": [],
          "tooltip": "The advertising brand is shown or spoken in the first 5 seconds"
        },
        {
          "id": 180,
          "label": "Voice Over Narration",
          "selected": 0,
          "collapse": 0,
          "parent": 100,
          "children": [],
          "tooltip": "An off-screen narrator is featured"
        },
        {
          "id": 190,
          "label": "Continuity",
          "selected": 0,
          "collapse": 0,
          "parent": 100,
          "children": [],
          "tooltip": "Ad uses the same creative construct and/or established brand cues"
        },

        {
          "id": 200,
          "label": "Product Type",
          "selected": 0,
          "collapse": 0,
          "parent": 0,
          "children": [
            210,
            220,
            230
          ],
          "tooltip": "This will be checked automatically when any item in this section is checked."
        },
        {
          "id": 210,
          "label": "PrePaid",
          "selected": 0,
          "collapse": 0,
          "parent": 200,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 220,
          "label": "PostPaid",
          "selected": 0,
          "collapse": 0,
          "parent": 200,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 230,
          "label": "Home Internet",
          "selected": 0,
          "collapse": 0,
          "parent": 200,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 300,
          "label": "Offer Type",
          "selected": 0,
          "collapse": 0,
          "parent": 0,
          "children": [
            310,
            320,
            330,
            340,
            350,
            360,
            370,
            380,
            390
          ],
          "tooltip": "This will be checked automatically when any item in this section is checked."
        },
        {
          "id": 310,
          "label": "Bundle Pricing (Services, Lines, etc.)",
          "selected": 0,
          "collapse": 0,
          "parent": 300,
          "children": [],
          "tooltip": "Includes bundled services (e.g. Mobile & Internet) or line bundles (e.g. up to 5 lines)"
        },
        {
          "id": 320,
          "label": "Cash Back/Credit/Rewards Cards",
          "selected": 0,
          "collapse": 0,
          "parent": 300,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 330,
          "label": "Free Equipment/Service",
          "selected": 0,
          "collapse": 0,
          "parent": 300,
          "children": [],
          "tooltip": "Includes free phones or phone on us"
        },
        {
          "id": 340,
          "label": "Free Trial",
          "selected": 0,
          "collapse": 0,
          "parent": 300,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 350,
          "label": "Limited Time/Special Discount",
          "selected": 0,
          "collapse": 0,
          "parent": 300,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 360,
          "label": "No Contract",
          "selected": 0,
          "collapse": 0,
          "parent": 300,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 370,
          "label": "No Fees",
          "selected": 0,
          "collapse": 0,
          "parent": 300,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 380,
          "label": "Premium Channels/Streaming Apps Included",
          "selected": 0,
          "collapse": 0,
          "parent": 300,
          "children": [],
          "tooltip": "Includes references to channels/apps like HBO, Showtime or Netflix, Hulu"
        },
        {
          "id": 390,
          "label": "Price Guarantee",
          "selected": 0,
          "collapse": 0,
          "parent": 300,
          "children": [],
          "tooltip": `Refers to any guarantee (e.g. "price for life", "life of contract" etc.)`
        }
      ]
    }
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/Tmobile/config/components/selection/Search/tagHierarchy.js